import { cn } from '@plato/ui/util/classes';
import type React from 'react';

type Props = {
    children?: React.ReactNode | React.ReactNode[];
    className?: string;
};

export function ListView({ children, className }: Props) {
    return <div className={cn('flex flex-row space-x-4 overflow-y-hidden', className)}>{children}</div>;
}

type BodyContainerProps = {
    children: React.ReactNode | React.ReactNode[];
};

function BodyContainer({ children }: BodyContainerProps) {
    return <div className="flex grow flex-col overflow-x-hidden">{children}</div>;
}

ListView.BodyContainer = BodyContainer;
